import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", { class: "border-bottom p-3 mb-0" }, "Are you still there?", -1 /* HOISTED */)
const _hoisted_2 = { class: "border-bottom p-3 pb-4 mb-0" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" You have been idle for a while. For security reasons, your session will expire in ")
const _hoisted_4 = { class: "d-flex justify-content-end p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("strong", null, _toDisplayString(_ctx.minutes) + ":" + _toDisplayString(_ctx.seconds), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-light border border-secondary me-1",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout()))
      }, "Log out"),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary border border-primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.stayLoggedIn()))
      }, " Stay Logged In ")
    ])
  ], 64 /* STABLE_FRAGMENT */))
}